<template>
  <div class="bills-box">
    <nav-index :title="'月结账单'"/>
    <!-- 去掉 tabs，改为展示所有历史账单 -->
    <div class="order-card-block">
      <div v-if="showEmptyImg && !billsLoading">
        <div class="none-list">
          <img src="../../assets/images/none.svg" alt="">
          <div class="none">暂无月结账单</div>
        </div>
      </div>
      <div v-else>
        <!-- 账单卡片列表 -->
        <div 
          class="bill-card" 
          v-for="(bill, index) in billList" 
          :key="index"
          @click="goBillDetail(bill)"
        >
          <div class="bill-header">
            <span class="bill-label">{{ bill.label }}</span>
            <span :class="getStatusClass(bill.status)">
              {{ getStatusText(bill.status) }}
            </span>
          </div>
          <div class="bill-body">
            <div class="bill-row">
              <span>期初余额</span>
              <span>¥{{ formatAmount(bill.beginReceivable - bill.beginPayable) }}</span>
            </div>
            <div class="bill-row">
              <span>期末余额</span>
              <span class="amount">¥{{ formatAmount(bill.netBalance) }}</span>
            </div>
            <div class="bill-row" v-if="bill.status === 'partial'">
              <span>已付金额</span>
              <span class="paid">¥{{ formatAmount(bill.paidAmount || 0) }}</span>
            </div>
          </div>
          <div class="bill-footer">
            <span class="detail-hint">查看明细 →</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavIndex from '../../components/nav/index.vue'
import { getMonthlyBillList } from '@/api/api'
import { getopenIdByCode } from '@/utils/index'
import { Toast } from 'vant'

export default {
  name: 'Bills',
  components: { NavIndex },
  data() {
    return {
      billList: [],
      showEmptyImg: false,
      billsLoading: false,
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo'))[0] : {}
    }
  },
  created() {
    this.$bus.$on('changeTaaab', this.changeTaaab)
    getopenIdByCode()
  },
  mounted() {
    this.getBillList()
  },
  methods: {
    getBillList() {
      const uid = this.userInfo?.uid
      if (!uid) {
        Toast('请先登录')
        return
      }
      this.billsLoading = true
      this.showEmptyImg = false
      getMonthlyBillList({ uid })
        .then(res => {
          if (res.data.code === 200) {
            const data = res.data.data
            this.billList = data.list || []
            this.showEmptyImg = this.billList.length === 0
          } else {
            Toast(res.data.message || '加载失败')
          }
        })
        .catch(() => Toast('网络异常'))
        .finally(() => {
          this.billsLoading = false
        })
    },
    goBillDetail(bill) {
      // 跳转详情页，传递起止日期
      this.$router.push({
        path: '/bills-detail',
        query: {
          startDate: bill.startDate || '',
          endDate: bill.endDate || '',
          label: bill.label || ''
        }
      })
    },
    getStatusClass(status) {
      const map = {
        'paid': 'status-paid',
        'partial': 'status-partial',
        'unpaid': 'status-unpaid'
      }
      return map[status] || 'status-unpaid'
    },
    getStatusText(status) {
      const map = {
        'paid': '已结清',
        'partial': '部分结清',
        'unpaid': '待结清'
      }
      return map[status] || '待结清'
    },
    formatAmount(val) {
      return Number(val).toFixed(2)
    },
    changeTaaab() {
      // 保留 tabs 切换能力，但新接口不再需要，可空实现或移除
    }
  }
}
</script>

<style scoped lang="scss">
.bills-box {
  min-height: 100vh;
  .order-card-block {
    padding: 95px 0 10px;
    padding-bottom: calc(10px + constant(safe-area-inset-bottom));
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
  }
}
.bill-card {
  background: #fff;
  margin: 10px 15px;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  cursor: pointer;
  transition: all 0.2s;
  &:active {
    transform: scale(0.98);
  }
  .bill-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;

    .bill-label {
      font-size: 14px;          // 稍微缩小字体
      font-weight: 600;
      color: #333;
      white-space: nowrap;       // ← 防止换行
      overflow: hidden;          // ← 防止溢出
      text-overflow: ellipsis;   // ← 过长显示省略号
      max-width: 70%;            // ← 限制宽度，让状态标签有空间
    }

    // 状态标签
    .status-paid { 
      color: #52c41a; 
      font-size: 13px; 
      white-space: nowrap;      // ← 也防止换行
    }
    .status-partial { color: #faad14; font-size: 13px; }
    .status-unpaid { color: #ff4d4f; font-size: 13px; }
  }
  .bill-body {
    padding: 12px 0 8px;
    .bill-row {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #666;
      padding: 4px 0;
      .amount {
        font-weight: 600;
        color: #ff4d4f;
      }
      .paid {
        font-weight: 600;
        color: #52c41a;
      }
    }
  }
  .bill-footer {
    text-align: right;
    padding-top: 8px;
    border-top: 1px solid #f5f5f5;
    .detail-hint {
      font-size: 13px;
      color: #999;
    }
  }
}
.none-list {
  margin: 60px auto 20px;
  width: 100%;
  max-width: 625px;
  .none {
    margin: 10px 0 0;
    color: #969699;
  }
  img {
    min-height: 142px;
  }
}
</style>